import { render, staticRenderFns } from "./payment-success.vue?vue&type=template&id=3ad3a90a&scoped=true&"
import script from "./payment-success.vue?vue&type=script&lang=js&"
export * from "./payment-success.vue?vue&type=script&lang=js&"
import style0 from "./payment-success.vue?vue&type=style&index=0&id=3ad3a90a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad3a90a",
  null
  
)

export default component.exports